<div id="cashflows-container">
  <div id="main-container">
    <!-- Form container OFFICE -->
    <div class="form-container" *ngIf="!this.isLoading">
      <div class="cashflows" *ngFor="let item of this.cashflows">
        <p class="heading-02-bold">{{ item.description }}</p>
        <qr-button
          *ngIf="item.type >= 6"
          [config]="buttonEdit"
          (click)="onEdit(item.type)"
          matTooltip="Editar"
        ></qr-button>
      </div>
    </div>
  </div>
</div>
